export enum RelationInvoicePeriod {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export const InvoicePeriodTranslations: Record<RelationInvoicePeriod, string> = {
  [RelationInvoicePeriod.MONTHLY]: 'Maandelijks',
  [RelationInvoicePeriod.QUARTERLY]: 'Per kwartaal',
};
